'use client';

import classNames from 'classnames';
import capitalize from 'lodash/capitalize';
import { useMemo, useState } from 'react';

import { usePricingPageContext } from '@/pricing/PricingPageContext';
import { OptionId } from '@/pricing/types';
import { Button } from '@/ui/Button/Button';

import { Section } from '../Section/Section';
import { TableHead } from '../TableHead/TableHead';

import { getKeyItems, getTableSections } from './utils';

import styles from './Table.module.scss';

interface Props {
    className?: string;
}

export function Table({ className }: Props) {
    const { pricingTable } = usePricingPageContext();
    const [showAllFeatures, setShowAllFeatures] = useState(false);
    const [isStuck, setIsStuck] = useState(false);

    const { rows } = pricingTable;
    const options = pricingTable.options.filter((option) => option.id !== OptionId.ENTERPRISE);

    const sections = useMemo(() => {
        const displayedRows = showAllFeatures ? rows : getKeyItems(rows);
        return getTableSections(displayedRows);
    }, [showAllFeatures, rows]);

    console.log(sections);

    return (
        <div className={classNames(styles.table, className)}>
            <TableHead
                className={classNames(styles.sticky, {
                    [styles.stuck]: isStuck,
                })}
                onStuck={setIsStuck}
                options={options}
            />
            {Object.keys(sections).map((section) => {
                const sectionRows = sections[section];

                return (
                    <Section
                        key={section}
                        section={capitalize(section === 'null' ? 'Other' : section)}
                        rows={sectionRows}
                        options={options.map((option) => option.id)}
                    />
                );
            })}
            {!showAllFeatures && (
                <div className={styles.compareAllFeaturesSection}>
                    <Button
                        size="large"
                        className={styles.compareAllFeaturesBtn}
                        onClick={() => setShowAllFeatures(true)}
                    >
                        See more
                    </Button>
                </div>
            )}
        </div>
    );
}
